import {useQuery} from 'react-query';
import {userChats} from 'services/wholesaler/chatList';

const useGetChatted = (params: UseGetChattedProps) => {
  const {data, isLoading, refetch} = useQuery(
    ['user-wholesaler-chats', params.app],
    userChats,
  );
  return {userChatData: data, userChatDataIsloading: isLoading, refetch};
};
export default useGetChatted;
